// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__vdwsF","right":"Footer_right__32dMf","buttons":"Footer_buttons__1yuMy"};